import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

const hideeplinkMap = {
  hicoach: "hicoach (standard leaf)",
  hicoachtwin: "hicoachtwin (second leaf on same computer)",
};

const getHideeplinkMapCopy = function () {
  // returning a copy, to avoid changes at main obj by importers
  return { ...hideeplinkMap };
};

const HiDeepLinkSelect = (props) => (
  <TextField
    fullWidth
    select
    InputLabelProps={{ shrink: true }}
    label={props.label || "HiDeepLink"}
    variant="outlined"
    {...props}
  >
    {props.allowEmpty && <MenuItem value={null}>-</MenuItem>}
    {props.addOptions &&
      Object.keys(props.addOptions).map((k) => {
        return (
          <MenuItem key={k} value={k}>
            {props.addOptions[k]}
          </MenuItem>
        );
      })}
    {Object.keys(hideeplinkMap).map((k) => {
      return (
        <MenuItem key={k} value={k}>
          {hideeplinkMap[k]}
        </MenuItem>
      );
    })}
  </TextField>
);

export default HiDeepLinkSelect;
export { getHideeplinkMapCopy };
